var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-text',{staticClass:"city-select head__city-select",attrs:{"icon":_vm.$t('PORTAL.HEAD.CITY-SELECTED.ICON')}},[_vm._v(" "+_vm._s(_vm.$t('PORTAL.HEAD.CITY-SELECTED.VALUE', {value: _vm.getCityValue}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }